import type { TrophyTier } from '@crowdfpl/domain/gamification';

/** Semantic surface classes for trophy tier accents (gold reuses core gold tokens). */
export function trophyTierToneClass(tier: TrophyTier | null | undefined): string {
  switch (tier) {
    case 'bronze':
      return 'border-trophy-bronze/50 bg-trophy-bronze/10 text-trophy-bronze';
    case 'silver':
      return 'border-trophy-silver/50 bg-trophy-silver/10 text-trophy-silver';
    case 'gold':
      return 'border-gold/50 bg-gold/10 text-gold-foreground';
    case 'platinum':
      return 'border-trophy-platinum/50 bg-trophy-platinum/10 text-trophy-platinum';
    case 'legendary':
      return 'border-trophy-legendary/50 bg-trophy-legendary/10 text-trophy-legendary';
    case 'mythic':
      return 'border-trophy-mythic/50 bg-trophy-mythic/10 text-trophy-mythic';
    default:
      return 'border-border bg-muted text-muted-foreground';
  }
}

/** Solid fill for ladder segments. */
export function trophyTierFillClass(tier: TrophyTier): string {
  switch (tier) {
    case 'bronze':
      return 'bg-trophy-bronze';
    case 'silver':
      return 'bg-trophy-silver';
    case 'gold':
      return 'bg-gold';
    case 'platinum':
      return 'bg-trophy-platinum';
    case 'legendary':
      return 'bg-trophy-legendary';
    case 'mythic':
      return 'bg-trophy-mythic';
    default:
      return 'bg-muted';
  }
}
